export const AppConfig = {
  publicUrl: process.env.PUBLIC_URL,
  isEnabledDocumentAccept: true,
};
